/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import {Icon, Button, Menu, Dropdown, message, Modal, Form, Row, Col, Radio, Input, /*Select, Table*/} from 'antd';
/*const Option = Select.Option;*/
import {DmsTab, TableView, FilterBox} from 'Components';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const {TextArea} = Input;
const MenuItemGroup = Menu.ItemGroup;
/*const Search = Input.Search;*/
import {accountList, accountAudit, accountInvalid, accountValid, accountResetPwd} from '../../service/account';


class Account extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			reviewFlag: false,
			selectedKeys: [],
			/*roleFlag: false,
			 role: '',*/
			modalTitle: '',
			key: 0,
			opts: ['账号管理'],
			filterBoxVisible: false,
			rows: [],
			total: 0,
			/*roleTotal: 0,*/
			/*pageSize: 10,
			 pageNo: 1,*/
			searchObj: {
				account: '',
				name: '',
				source: '',
				status: '',
				p:1,
				s:10
			},
			/*data: [{
			 key: '1',
			 role: '系统管理员',
			 rolecode: 'admin',
			 rolestatus: '启用'
			 }, {
			 key: '2',
			 role: '品牌商',
			 rolecode: 'BM',
			 rolestatus: '启用'
			 }]*/
		};
		
		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.dropdownClick = this.dropdownClick.bind(this);
		/*this.rolePageChange = this.rolePageChange.bind(this);*/
		this.handleOk = this.handleOk.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		/*this.onChange = this.onChange.bind(this);*/
		/*this.getCheckboxProps = this.getCheckboxProps.bind(this);*/
		this.getData = this.getData.bind(this);
	}
	
	componentDidMount() {
		this.getData(this.state.storeData);
	}
	
	//获取数据
	getData() {
		var obj=this.state.searchObj;
		accountList(obj).then(result => {
			if (result.status) {
				var accountArr = result.data;
				this.setState({
					rows: accountArr,
					total: result.total
				})
			} else {
				message.error(result.message);
			}
		})
	}
	
	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}
	
	advanceReset() {
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: {
				...this.state.searchObj,
				account: '',
				name: '',
				source: '',
				status: '',
				p:1
			}
		}, () => {
			self.getData();
		});
	};
	
	advanceSubmit(form) {
		var submitObj = this.state.searchObj;
		submitObj.p = 1;
		if (submitObj.status === '1') {
			submitObj.status = 1;
		} else if (submitObj.status === '2') {
			submitObj.status = 0;
		} else if (submitObj.status === '3') {
			submitObj.status = 2;
		} else {
			var newObj = {};
			for (var o in submitObj) {
				if (o != 'status') {
					newObj[o] = submitObj[o]
				}
			}
			submitObj = newObj;
		}
		
		if (submitObj.source === '1') {
			submitObj.source = 1;
		} else if (submitObj.source === '2') {
			submitObj.source = 2;
		} else if (submitObj.source === '3') {
			submitObj.source = 3;
		} else {
			var sourceObj = {};
			for (var x in submitObj) {
				if (x != 'source') {
					sourceObj[x] = submitObj[x]
				}
			}
			submitObj = sourceObj;
		}
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: submitObj}, function () {
			self.getData();
		});
	};
	
	setFilterParam(name, value) {
		this.setState({searchObj: {...this.state.searchObj, [name]: value}});
	};
	
	pageChange(page, pageSize) {
		const self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.getData();
		});
	}
	
	/*rolePageChange(p, s) {
	 this.setState({pageSize: p, pageNo: s});
	 }*/
	
	//弹出框
	handleOk = () => {
		const self = this;
		const {validateFields, getFieldsValue, /* getFieldValue*/} = this.props.form;
		var dataAudit = this.state.rows[this.state.key];
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			
			
			//修改状态--审核
			if (self.state.reviewFlag) {
				accountAudit({...data, id: dataAudit.id}).then(result => {
					if (result.status) {
						message.success(result.message);
						this.getData();
					} else {
						message.error(result.message);
					}
				})
			}
			
			
			/*//角色选择
			 if (this.state.roleFlag) {
			 if (this.state.role != '') {
			 var roleArr = this.state.rows;
			 roleArr[this.state.key].character = this.state.role;
			 this.setState({
			 rows: roleArr
			 })
			 }
			 }*/
			
			this.setState({
				visible: false,
				reviewFlag: false,
				/*roleFlag: false*/
			});
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false,
			reviewFlag: false,
			/*roleFlag: false*/
		});
	}
	
	onVisibleChange(visible) {
		this.setState({
			selectedKeys: []
		});
	}
	
	//下拉框选中事件
	dropdownClick({item, key, keyPath}) {
		const {selectedKeys} = this.state;
		selectedKeys.push(key);
		this.setState({
			selectedKeys
		});
		var arr = key.split('_');
		if (this.state.rows[arr[1]].status === 2) {
			//审核
			/*var datas = this.state.rows;*/
			this.setState({
				visible: true,
				reviewFlag: true,
				/*roleFlag: false,*/
				key: arr[1],
				modalTitle: '账号审核'
			});
		} else {
			if (arr[0] === '0') {
				if (this.state.rows[arr[1]].status === 1) {
					//禁用账号
					accountInvalid({id: this.state.rows[arr[1]].id}).then(result => {
						if (result.status) {
							message.success(result.message);
							this.getData();
						} else {
							message.error(result.message);
						}
					})
				} else {
					//启用账号
					accountValid({id: this.state.rows[arr[1]].id}).then(result => {
						if (result.status) {
							message.success(result.message);
							this.getData();
						} else {
							message.error(result.message);
						}
					})
				}
				
			}
			;
			//重置密码
			if (arr[0] === '1') {
				accountResetPwd({id: this.state.rows[arr[1]].id}).then(result => {
					if (result.status) {
						message.success(result.message);
						this.getData();
					} else {
						message.error(result.message);
					}
				})
			}
			;
			
			/*//分配角色
			 if (arr[0] === '2') {
			 this.setState({
			 visible: true,
			 reviewFlag: false,
			 roleFlag: true,
			 key: arr[1],
			 modalTitle: '分配角色'
			 })
			 }*/
		}
	}
	
	
	/*//分配角色
	 onChange = (selectedRowKeys, selectedRows) => {
	 var roleStr = '';
	 for (var i = 0; i < selectedRows.length; i++) {
	 roleStr += selectedRows[i].role + ';';
	 }
	 this.setState({
	 role: roleStr
	 })
	 
	 }*/
	
	/*getCheckboxProps = (record) => {
	 return {disabled: record.role === 'Disabled Role'}   // Column configuration not to be checked
	 }*/
	
	menu(index) {
		return <Menu style={{width: "100px", textAlign: 'center', color: 'green'}}
					 onClick={this.dropdownClick}
					 selectedKeys={this.state.selectedKeys}>
			{this.state.rows[index].status === 2 && <Menu.Item key={`4_${index}`}>审核</Menu.Item>}
			{this.state.rows[index].status === 0 && <Menu.Item key={`0_${index}`}>启用账号</Menu.Item>}
			{this.state.rows[index].status === 1 && <MenuItemGroup>
				<Menu.Item key={`0_${index}`}>
					禁用账号
				</Menu.Item>
				<Menu.Item key={`1_${index}`}>
					{
						this.state.rows[index].status === 0 ?
							""
							:
							"重置密码"
					}
				</Menu.Item>
				{/*<Menu.Item key={`2_${index}`}>
				 {
				 this.state.rows[index].status === 0 ?
				 ""
				 :
				 "分配角色"
				 }
				 </Menu.Item>*/}
			</MenuItemGroup>
			}
		</Menu>
	}
	
	render() {
		const {/*roleTotal, pageSize, pageNo,*/opts, filterBoxVisible, rows, total, modalTitle, reviewFlag, /*roleFlag, data*/} = this.state;
		const {getFieldDecorator} = this.props.form;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'account',
						label: '账号',
						text: '请输入账号',
						type: 'default'
					},
					{
						name: 'name',
						label: '姓名',
						text: '请输入姓名',
						type: 'default'
					},
					{
						name: 'source',
						label: '来源',
						text: "全部",
						options: [
							{value: '0', text: '全部'},
							{value: '1', text: '员工'},
							{value: '2', text: '渠道商'},
							{value: '3', text: '门店'}
						],
						type: 'select'
					},
					{
						name: 'status',
						label: '状态',
						text: "全部",
						options: [
							{value: '0', text: '全部'},
							{value: '1', text: '启用'},
							{value: '2', text: '禁用'},
							{value: '3', text: '待审核'}
						],
						type: 'select'
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total,
				current: this.state.searchObj.p,//当前页码
				pageSize: this.state.searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [{
				title: '账号',
				dataIndex: 'account',
				render: text => <span>{text}</span>,
			}, {
				title: '姓名',
				dataIndex: 'name',
			}, {
				title: '角色',
				dataIndex: 'roleName',
			}, {
				title: '状态',
				dataIndex: 'statusText',
			}, {
				title: '来源',
				dataIndex: 'sourceText',
			}, {
				title: '创建时间',
				dataIndex: 'createdDate',
			}, {
				title: '上一次登录',
				dataIndex: 'lastLoginDate',
				render: (text) => text || ''
			}, {
				title: '更多操作',
				key: 'action',
				className: 'alignCenter',
				render: (text, record, index) => (
					<Dropdown overlay={this.menu(index)}
							  placement='bottomCenter'
							  trigger={['click']}
							  onVisibleChange={this.onVisibleChange.bind(this)}>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
					</Dropdown>
				)
			}],
			rows
		};
		/*const tableValue = {
		 columns: [{
		 title: '角色',
		 dataIndex: 'role'
		 }, {
		 title: '编码',
		 dataIndex: 'rolecode',
		 }, {
		 title: '状态',
		 dataIndex: 'rolestatus',
		 }],
		 rowSelection: {
		 onChange: this.onChange,
		 getCheckboxProps: this.getCheckboxProps
		 },
		 dataSource: data,
		 pagination: {
		 roleTotal,
		 pageSize: pageSize,
		 pageSizeOptions: ['1', '10', '20', '30', '40'],
		 showTotal: total => `共 ${total} 条`,
		 showSizeChanger: true,
		 showQuickJumper: true,
		 onChange: this.rolePageChange,
		 size: "small",
		 current: pageNo
		 }
		 }*/
		
		//决定弹框中的内容
		const showMain = () => {
			if (reviewFlag == true) {
				return (
					<Form layout="horizontal">
						<Row>
							<Col className="gutter-row" span={12}>
								<FormItem label="审核意见">
									{getFieldDecorator('auditOpinion', {
										rules: [
											{
												required: true,
											}
										]
									})(
										<RadioGroup>
											<Radio value="1">同意</Radio>
											<Radio value="0">拒绝</Radio>
										</RadioGroup>
									)}
								</FormItem>
							</Col>
						</Row>
						
						<Row>
							<Col className="gutter-row">
								<FormItem label="备注">
									{getFieldDecorator('auditRemark')(
										<TextArea rows={3}/>
									)}
								</FormItem>
							</Col>
						</Row>
					</Form>
				)
			}
			
			/*if (roleFlag == true) {
			 return (
			 <div>
			 <Search style={{width: '300px', marginBottom: '10px'}} placeholder="搜索角色"/>
			 <Table {...tableValue}/>
			 </div>
			 )
			 }*/
		}
		return (
			<div className='dms-body'>
				<div>
					<DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
						<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
						<FilterBox  {...filterBoxProps}/>
					</DmsTab>
				</div>
				
				<div className="dms-table-box">
					<TableView {...tableViewProps} />
				</div>
				
				<Modal
					title={modalTitle}
					visible={this.state.visible}
					onOk={this.handleOk}
					onCancel={this.handleCancel}
				>
					{
						showMain()
					}
				
				</Modal>
			</div>
		)
	}
}
;
export default Form.create()(Account);



// WEBPACK FOOTER //
// ./src/routes/account/index.js